import { render, staticRenderFns } from "./SetDocumentDueDate.vue?vue&type=template&id=2ab5e53a&scoped=true"
import script from "./SetDocumentDueDate.vue?vue&type=script&lang=js"
export * from "./SetDocumentDueDate.vue?vue&type=script&lang=js"
import style0 from "./SetDocumentDueDate.vue?vue&type=style&index=0&id=2ab5e53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5e53a",
  null
  
)

export default component.exports